module.exports = __webpack_public_path__ + "zm.svg?d9c64562af3524f4a4e527327ac9ccf3";